export default "__VITE_ASSET__qwA03sjH__"